// This file defines and exports constant route paths used across the app.
export const UnauthorizedPath = "/unauthorized";
export const ForbiddenPath = "/ns";
export const NotFoundPath = "*";

// routes.ts

export const ROUTES = {
  dashboard: {
    root: "/",
    dashboard: "/dashboard",
    lowBatteryMeters: "/dashboard/low-battery-meters",
    offlineMeters: "/dashboard/offline-meters",
    metrixInsights: "/metrix-insights",
  },

  management: {
    root: "/management",
    meters: "/management/meters",
    virtualMeters: "/management/virtual-meters",
    sites: "/management/sites",
    meterGroups: "/management/meter-groups",
    users: "/management/users",
    roles: "/management/roles",
    contacts: "/management/contacts",
    companySettings: "/management/company-settings",
  },

  reportingSetup: {
    root: "/reporting",
    enem12: "/reporting/enem12",
    nem12: "/reporting/nem12",
    mdn: "/reporting/mdn",
    nem12QualityFlag: "/reporting/nem12-quality-flag",
    meterEvent: "/reporting/meter-event",
    orionCumulative: "/reporting/orion-cumulative",
    siteUsage: "/reporting/site-usage",
    validation: "/reporting/validation",
  },

  reporting: {
    view: "/reporting/history",
    validationHistory: "/reporting/validation-history",
    validationSummary: "/reporting/validation-summary",
    advancedEco: "/reporting/advanced-eco-validation",
    iotData: "/reporting/iot-data-summary",
    anomalyDashboard: "/reporting/anomaly-dashboard",
  },

  monitoring: {
    root: "/monitoring",
    deviceStatus: "/monitoring/device-status",
    meterSchedules: "/monitoring/meter-schedules",
    meterDataAudit: "/monitoring/meter-data-audit",
  },

  dataTools: {
    root: "/data-tools",
    dataCorrections: "/data-tools/data-corrections",
    nmiGenerator: "/data-tools/nmi-generator",
    serialGenerator: "/data-tools/serial-generator",
    propertyGenerator: "/data-tools/property-generator",
    nem12: "/data-tools/nem12-viewer",
  },
  provisioning: {
    root: "/provisioning",
    importMeters: "/provisioning/import-meters",
    unprovisionedMeters: "/provisioning/unprovisioned-meters",
    unprovisionedIotDevices: "/provisioning/unprovisioned-iot-devices",
  },

  alarmsSetup: {
    root: "/alarms-setup",
    meterAlarmEvent: "/alarms-setup/meter-alarm-event",
    iotPayload: "/alarms-setup/iot-payload",
  },
  integrations: {
    root: "/integrations",
    iotDataSync: "/integrations/iot-sync",
    cetDataSync: "/integrations/cet-sync",
    advancedEcoDataSync: "/integrations/advanced-eco-sync",
  },
  logs: {
    root: "/logs",
    systemLogs: "/logs/view-logs",
    userAuditLogs: "/logs/user-audit",
    maintenance: "/logs/maintenance",
  },
  system: {
    root: "/system",
    configuration: "/system/configuration",
    meterStatusCodes: "/system/meter-status-codes",
    application: "/system/application",
    contactSupport: "/system/contact-support",
  },
  header: {
    profile: "/profile",
    superset: {
      configuration: "/superset/configuration",
    },
    acknowledge: "/acknowledge",
    authentication: "/authentication",
    contactSupport: "/contact-support",
    logOut: "/log-out",
  },
  notFound: "/not-found",
} as const;

// Defines reusable constants used throughout the application.
import { Icons } from "@/assets/images";

const headerNav = [
  {
    iconSrc: Icons.headerDarkModeIcon,
    darkSrc: Icons.sunIcon,
    iconAlt: "DarkMode Icon",
  },
  {
    iconSrc: Icons.headerVerifiedIcon,
    iconAlt: "Verified Icon",
  },
  {
    iconSrc: Icons.headerBellInitialIcon,
    iconAlt: "Bell Icon",
    hasNotif: true,
  },
];

const headerSubMenu = [
  {
    menuListIcon: Icons.personIcon,
    menuListIconAlt: "Profile Icon",
    menuListTxt: "Profile",
    menuListLink: ROUTES.header.profile,
  },
  {
    menuListIcon: Icons.supersetIcon,
    menuListIconAlt: "Insights Preferences Icon",
    menuListTxt: "Insights Preferences",
    menuListLink: ROUTES.header.superset.configuration,
  },
  {
    menuListIcon: Icons.thumbsUpIcon,
    menuListIconAlt: "Thumbs Up Icon",
    menuListTxt: "Acknowledge",
    menuListLink: ROUTES.header.acknowledge,
  },
  {
    menuListIcon: Icons.authShieldIcon,
    menuListIconAlt: "Authentication Icon",
    menuListTxt: "Authentication",
    menuListLink: ROUTES.header.authentication,
  },
  {
    menuListIcon: Icons.contactSupportIcon,
    menuListIconAlt: "Contact Support Icon",
    menuListTxt: "Contact Support",
    menuListLink: ROUTES.header.contactSupport,
  },
  {
    menuListIcon: Icons.headerDarkModeIcon,
    menuListDarkIcon: Icons.sunIcon,
    menuListIconAlt: "Theme-toggle-icon",
    menuListTxt: "Toggle Theme",
    btn: "theme-toggle",
  },
  {
    menuListIcon: Icons.headerVerifiedIcon,
    menuListDarkIcon: Icons.headerVerifiedIcon,
    menuListIconAlt: "Verified-icon",
    menuListTxt: "Validation Notifications",
    btn: "data-validation-notifications",
  },
  {
    menuListIcon: Icons.logOutIcon,
    menuListIconAlt: "Log Out Icon",
    menuListTxt: "Log Out",
    menuListLink: ROUTES.header.logOut,
  },
];

export { headerNav, headerSubMenu };
